import type { TaxInvoiceView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
export const OrderTaxInvoiceRow = ({ view }: { readonly view: TaxInvoiceView }): ReactElement => (
  <div className="flex gap-4 py-3">
    <dt className="w-24 shrink-0 text-muted-foreground">세금계산서</dt>
    <dd>
      {view.status === 'NONE'
        ? '요청 안 함'
        : view.status === 'CANCELED'
          ? '취소됨'
          : view.status === 'ISSUED'
            ? `발행 완료 · 승인번호 ${view.ntsConfirmNum ?? '확인 중'}`
            : '발행 준비 중'}
    </dd>
  </div>
);
